// Menu Configuration for PlexiSystem 4.0 - PRODUKCYJNY
// Reorganizacja modułów w centra tematyczne - ulepszone ikony

import { 
  Home, Calculator, FileText, Users, TrendingUp, Activity, Euro,
  Wrench, Settings, ClipboardCheck, Warehouse,
  Share2, Bell, MessageCircle,
  Brain, Zap,
  Box, Eye, Package, Palette,
  Database, Thermometer, Sparkles, Shield,
  BarChart2, ShoppingBag, Target, Award, Rocket,
  Factory, Cpu, FlaskConical, Gauge, 
  DollarSign, ShoppingCart, Briefcase, HandshakeIcon,
  LineChart, Megaphone, HelpCircle, BarChart3, Search
} from 'lucide-react';

export interface MenuItem {
  id: string;
  label: string;
  icon: React.ElementType;
  href: string;
  badge?: {
    text: string;
    color?: string;
    gradient?: string;
    pulse?: boolean;
  };
  category?: string;
  keywords?: string[];
  checkAccess?: () => boolean;
  color?: string;
  description?: string;
  priority?: number;
}

export interface MenuCategory {
  id: string;
  title: string;
  icon: React.ElementType;
  items: MenuItem[];
  color: string;
  description?: string;
}

// ULEPSZONA ORGANIZACJA - CENTRA TEMATYCZNE (KOMPAKTOWE)
export const menuCategories: MenuCategory[] = [
  {
    id: 'ai',
    title: '🤖 AI & Automatyzacja',
    icon: Sparkles,
    color: 'purple',
    description: 'Sztuczna inteligencja i automatyzacja',
    items: [
      {
        id: 'ai-assistant',
        label: 'AI Assistant',
        icon: Brain,
        href: '/ai',
        badge: { text: 'GPT-4', color: 'bg-purple-500' },
        keywords: ['ai', 'asystent', 'chat', 'gpt'],
        priority: 1
      },
      {
        id: 'preset-harvester',
        label: 'Preset Harvester',
        icon: Search,
        href: '/admin/presets',
        badge: { text: '🔥 HOT', color: 'bg-gradient-to-r from-amber-500 to-orange-500' },
        keywords: ['preset', 'harvester', 'konkurencja', 'analiza'],
        priority: 2
      },
      {
        id: 'social-media',
        label: 'Social Media',
        icon: Share2,
        href: '/social-media',
        badge: { text: 'AUTO', color: 'bg-blue-500' },
        keywords: ['facebook', 'instagram', 'marketing'],
        priority: 2
      },
      {
        id: 'google-ads',
        label: 'Google Ads',
        icon: LineChart,
        href: '/google-ads',
        badge: { text: 'AI', color: 'bg-orange-500' },
        keywords: ['google', 'ads', 'reklamy'],
        priority: 3
      },
      {
        id: 'automation',
        label: 'Workflow',
        icon: Zap,
        href: '/automation',
        keywords: ['automatyzacja', 'workflow'],
        priority: 4
      },
      {
        id: 'chatbot',
        label: 'Chatbot',
        icon: MessageCircle,
        href: '/test-chatbot',
        keywords: ['chat', 'bot'],
        priority: 5
      },
      {
        id: 'chatbot-settings',
        label: 'Ustawienia Bota',
        icon: Settings,
        href: '/chatbot-settings',
        keywords: ['chatbot', 'konfiguracja'],
        priority: 6
      },
      {
        id: 'templates',
        label: 'Szablony odpowiedzi',
        icon: FileText,
        href: '/templates',
        badge: { text: 'NEW', color: 'bg-gradient-to-r from-green-500 to-emerald-500' },
        keywords: ['szablon', 'template', 'odpowiedź', 'wiadomość'],
        priority: 7,
        description: 'Zarządzaj szablonami wiadomości i odpowiedzi'
      }
    ]
  },
  
  {
    id: 'logistics',
    title: '📦 Logistyka',
    icon: Package,
    color: 'orange',
    description: 'Sprzedaż i produkcja',
    items: [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: BarChart2,
        href: '/dashboard',
        keywords: ['panel', 'statystyki'],
        priority: 1
      },
      {
        id: 'dashboard-new',
        label: 'Crystal',
        icon: Sparkles,
        href: '/dashboard-new',
        badge: { text: 'LIVE', color: 'bg-purple-500' },
        keywords: ['panel', 'crystal'],
        priority: 2
      },
      {
        id: 'offers',
        label: 'Oferty',
        icon: FileText,
        href: '/offers',
        keywords: ['oferta', 'wycena'],
        priority: 3
      },
      {
        id: 'production',
        label: 'Produkcja',
        icon: Factory,
        href: '/production',
        keywords: ['zlecenie', 'produkcja'],
        priority: 4
      },
      {
        id: 'quality',
        label: 'Kontrola QA',
        icon: ClipboardCheck,
        href: '/quality',
        badge: { text: 'QA', color: 'bg-green-500' },
        keywords: ['jakość', 'kontrola'],
        priority: 5
      },
      {
        id: 'notifications',
        label: 'Powiadomienia',
        icon: Bell,
        href: '/notifications',
        badge: { text: 'LIVE', color: 'bg-red-500' },
        keywords: ['telegram', 'alert'],
        priority: 6
      },
      {
        id: 'gantt',
        label: 'Gantt Chart',
        icon: BarChart3,
        href: '/gantt',
        badge: { text: 'NEW', color: 'bg-gradient-to-r from-violet-500 to-purple-500', gradient: true },
        keywords: ['gantt', 'harmonogram', 'timeline', 'wykres', 'zadania'],
        priority: 7,
        description: 'Zaawansowany wykres Gantta do zarządzania projektami'
      }
    ]
  },

  {
    id: 'finance',
    title: '💰 Finanse',
    icon: TrendingUp,
    color: 'green',
    description: 'Wyceny i rozliczenia',
    items: [
      {
        id: 'calculator',
        label: 'Kalkulator',
        icon: Calculator,
        href: '/calculator',
        keywords: ['wycena', 'cena'],
        priority: 1
      },
      {
        id: 'calculator-pro',
        label: 'Kalk. PRO',
        icon: Sparkles,
        href: '/calculator-pro',
        badge: { text: 'PRO', color: 'bg-purple-500' },
        keywords: ['wycena', 'crystal'],
        priority: 2
      },
      {
        id: 'profitability',
        label: 'Rentowność',
        icon: TrendingUp,
        href: '/profitability',
        keywords: ['marża', 'zysk'],
        priority: 3
      },
      {
        id: 'clients',
        label: 'Klienci CRM',
        icon: Users,
        href: '/clients',
        keywords: ['klient', 'kontrahent'],
        priority: 4
      },
      {
        id: 'payroll',
        label: 'Kadry i Płace',
        icon: Euro,
        href: '/payroll',
        keywords: ['pensja', 'kadry'],
        priority: 5
      },
      {
        id: 'reports',
        label: 'Raporty',
        icon: Activity,
        href: '/reports',
        keywords: ['raport', 'analiza'],
        priority: 6
      }
    ]
  },

  {
    id: 'marketing',
    title: '📢 Marketing',
    icon: Megaphone,
    color: 'blue',
    description: 'Sprzedaż i marketing',
    items: [
      {
        id: 'marketplace',
        label: 'Marketplace',
        icon: ShoppingBag,
        href: '/marketplace',
        badge: { text: 'B2B', color: 'bg-green-500' },
        keywords: ['sklep', 'zakupy'],
        priority: 1
      },
      {
        id: 'expositor-designer',
        label: 'Ekspozytory',
        icon: Package,
        href: '/expositor-designer',
        keywords: ['ekspozytor', 'design'],
        priority: 2
      },
      {
        id: 'packaging-configurator',
        label: 'Opakowania',
        icon: Box,
        href: '/packaging-configurator',
        keywords: ['opakowanie', 'pudełko'],
        priority: 3
      }
    ]
  },

  {
    id: 'tools3d',
    title: '🎨 Narzędzia 3D',
    icon: Box,
    color: 'indigo',
    description: '3D i wizualizacje',
    items: [
      {
        id: 'configurator3d',
        label: 'Konfigurator 3D',
        icon: Box,
        href: '/configurator3d',
        badge: { text: '3D', color: 'bg-indigo-500' },
        keywords: ['3d', 'model'],
        priority: 1
      },
      {
        id: 'visualizer',
        label: 'Wizualizator',
        icon: Eye,
        href: '/visualizer',
        badge: { text: 'AR', color: 'bg-teal-500' },
        keywords: ['wizualizacja', 'ar', 'vr'],
        priority: 2
      }
    ]
  },

  {
    id: 'technical',
    title: '⚙️ Techniczne',
    icon: Settings,
    color: 'gray',
    description: 'Narzędzia techniczne',
    items: [
      {
        id: 'machining',
        label: 'Parametry CNC',
        icon: Cpu,
        href: '/machining',
        badge: { text: 'CNC', color: 'bg-gray-500' },
        keywords: ['frez', 'cnc'],
        priority: 1
      },
      {
        id: 'laser-co2',
        label: 'Laser CO2',
        icon: Zap,
        href: '/laser-co2',
        keywords: ['laser', 'cięcie'],
        priority: 2
      },
      {
        id: 'bending-calculator',
        label: 'Gięcie',
        icon: Gauge,
        href: '/bending-calculator',
        keywords: ['gięcie', 'zaginanie'],
        priority: 3
      },
      {
        id: 'thermoforming',
        label: 'Termoform.',
        icon: Thermometer,
        href: '/thermoforming-calculator',
        keywords: ['termoformowanie'],
        priority: 4
      },
      {
        id: 'polishing',
        label: 'Polerowanie',
        icon: Sparkles,
        href: '/polishing-calculator',
        keywords: ['polerowanie'],
        priority: 5
      },
      {
        id: 'gluing',
        label: 'Klejenie',
        icon: FlaskConical,
        href: '/gluing-calculator',
        keywords: ['klejenie', 'klej'],
        priority: 6
      },
      {
        id: 'materials-database',
        label: 'Materiały',
        icon: Database,
        href: '/materials-database',
        keywords: ['materiał', 'plexi'],
        priority: 7
      }
    ]
  },

  {
    id: 'help',
    title: '❓ Pomoc',
    icon: HelpCircle,
    color: 'teal',
    description: 'Pomoc i dokumentacja',
    items: [
      {
        id: 'knowledge',
        label: 'Baza Wiedzy',
        icon: Award,
        href: '/knowledge',
        keywords: ['wiedza', 'tutorial'],
        priority: 1
      },
      {
        id: 'technical-docs',
        label: 'Dokumentacja',
        icon: FileText,
        href: '/technical',
        keywords: ['dokumentacja'],
        priority: 2
      },
      {
        id: 'system-health',
        label: 'Status',
        icon: Activity,
        href: '/system-health',
        badge: { text: 'LIVE', color: 'bg-red-500' },
        keywords: ['system', 'status'],
        priority: 3
      }
    ]
  },

  {
    id: 'admin',
    title: '🔒 Administracja',
    icon: Shield,
    color: 'red',
    description: 'Panel administracyjny',
    items: [
      {
        id: 'admin',
        label: 'Panel Admina',
        icon: Shield,
        href: '/admin',
        keywords: ['admin', 'użytkownicy'],
        priority: 1
      },
      {
        id: 'settings',
        label: 'Ustawienia',
        icon: Settings,
        href: '/settings',
        keywords: ['ustawienia', 'konfiguracja'],
        priority: 2
      },
      {
        id: 'api-settings',
        label: 'API AI',
        icon: Brain,
        href: '/api-settings',
        badge: { text: 'API', color: 'bg-purple-500' },
        keywords: ['api', 'ai', 'openai'],
        priority: 3
      }
    ]
  }
];

// Eksportujemy płaską listę wszystkich modułów
export const allMenuItems = menuCategories.flatMap(cat => 
  cat.items.map(item => ({ 
    ...item, 
    category: cat.title
  }))
);

// Domyślne ulubione moduły
export const defaultFavorites = ['dashboard', 'calculator-pro', 'offers', 'production', 'ai-assistant', 'configurator3d'];

// Mapowanie ról do kategorii
export const categoryAccessMap = {
  admin: ['ai', 'logistics', 'finance', 'marketing', 'tools3d', 'technical', 'help', 'admin'],
  kierownik_produkcji: ['logistics', 'finance', 'technical', 'help'],
  handlowiec: ['ai', 'logistics', 'finance', 'marketing', 'tools3d', 'help'],
  operator: ['logistics', 'technical', 'help'],
  magazynier: ['logistics', 'technical', 'help'],
  klient: ['help']
};
